import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { AuthenticationService } from '../_services/authentication.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add auth header with jwt if user is logged in and request is to api url
    const token = this.authenticationService.atualUserTokenValue;
    const atualUser = this.authenticationService.atualUserValue;
    const isLoggedIn = atualUser && token;
    let requireAuth = false;

    for (const key in environment.authorizedUrls) {
      if (Object.prototype.hasOwnProperty.call(environment.authorizedUrls, key)) {
        const url = environment.authorizedUrls[key];
        if (request.url.startsWith(url)) {
          requireAuth = true;
          break;
        }
      }
    }

    if (isLoggedIn && requireAuth) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(request);
  }
}
